import React, { useContext, useEffect } from 'react'
import { Auth } from '../../Contexts/AuthContext';
import logo from '../../Image/dreamstars_logo_white_s.png'
import hamburger from '../../favicon/navigation_bar.png'
import close from '../../favicon/close.png'
import favorite from '../../favicon/favorite.png'
import notification from '../../favicon/notification.png'
import wallet from '../../favicon/wallet.png'
import bgNew2 from '../../Image/bgNew2.png'
import profile from '../../Image/profile.svg'
import Sidebar from './Sidebar';
import { Link } from 'react-router-dom';
import currencyFormatter from '../../Helpers/currencyFormatter';
import { APIRequest, ApiUrl } from '../../Helpers/ApiHelper';
import { motion } from "framer-motion"



const Header = () => {
  const { auth, setShowSidebar, showSidebar, favoriteCounts, setAuth } = useContext(Auth);
  useEffect(() => {
    getWalletBalance();

    if (showSidebar ) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
  }, [showSidebar]);

  const getWalletBalance = () => {
    let config = {
      url: auth?.userRole === "BRAND" ? ApiUrl.brandGetWalletBalance : ApiUrl.influencerGetWalletBalance,
      method: 'GET',
      body: {},
    };

    APIRequest(
      config,
      res => {
        localStorage.setItem('user', JSON.stringify(res?.data));
        setAuth({
          ...auth,
          user: res?.data,
        })

      },
      err => {
        // setIsLoading(false);
      },
    );

  }


  return (
    <>
      <nav style={{ backgroundImage: `url(${bgNew2})` }} className=" bg-center bg-no-repeat bg-cover  h-28  max-w-full  ">

        <div className="lg:mx-10 mx-3 items-center h-full flex justify-between ">
          <div className=" flex  min-w-[70%]">
            {!showSidebar ? <div className=" lg:mt-4 mb-4 cursor-pointer max-w-[180px] sm:w-fit  ease-in-out duration-500"><Link to="/" ><img src={logo} alt="logo_img" className="w-auto" /></Link> </div> : null}
            {auth?.token &&
              <div className=' flex items-center justify-around lg:min-w-[60%]  ' >
                <div className='bg-white w-[1px] h-12 lg:block hidden  ' ></div>

                <div className=' h-20 w-20  lg:block hidden '>
                  <Link to='/profile'>
                    <img className='rounded-full h-20 w-20 object-cover object-top' src={auth?.user?.avatar ? auth?.user?.avatar : profile} title="Title of image" alt="Some Err" />
                  </Link>
                </div>


                <div className='lg:block hidden font-museob ' >
                  <span>Hello,</span>
                  <p className='font-museobb text-black'>{auth?.userRole === "BRAND" ? auth?.user?.owner_name : auth?.user?.name}</p>
                </div>


                <div className='bg-[#BBD5E8] rounded-full  min-w-[216px] min-h-[56px] items-center lg:flex hidden '>
                  <div className=' bg-[#9EC8E4] border-[3px] border-white min-w-[64px] min-h-[64px] flex items-center justify-center rounded-full'>
                    <img src={wallet} className=" w-6 h-6" alt="" />
                  </div>

                  <div className='mx-4'>
                    <span className='text-[11px] font-museob '>Dreams Wallet</span>
                    <p className='text-black font-museobb'>RM {currencyFormatter.format(auth?.user?.wallet_balance)}</p>


                  </div>

                </div>
              </div>
            }

          </div>




          <div className="flex items-center relative justify-around w-fit lg:w-20 ">

            <div className='relative mx-1'>
              <p className="bg-[#3870c5] ssm:w-7 ssm:h-7  w-6 h-6 rounded-full flex justify-center items-center" style={{ "boxShadow": "rgb(0 0 0 / 20%) 0px 1px 1px 1px, rgb(217 215 215 / 82%) -1px -3px 4px 1px" }} >
                <img className='ssm:w-2.5 ssm:h-2.5 w-2 h-2' src={notification} alt="" />
              </p>
            </div>
            <div className='relative mx-1'>
              <Link to={`${auth?.userRole === 'BRAND' ? '/my-campaigns?serach=fav' : '/campaigns?serach=fav'}`}>
                <p className="bg-[#3870c5] ssm:w-7 ssm:h-7  w-6 h-6 rounded-full flex justify-center items-center" style={{ "boxShadow": "rgb(0 0 0 / 20%) 0px 1px 1px 1px, rgb(217 215 215 / 82%) -1px -3px 4px 1px" }} >
                  <img className='ssm:w-2.5 ssm:h-2.5 w-2 h-2' src={favorite} alt="" />
                </p>
                {favoriteCounts > 0 && (<p className=' animate-bounce   ssm:w-4  w-3 rounded-full text-center text-[8px] ssm:text-[10px] ssm:h-4  h-3 absolute text-white  ssm:font-museob inset-x-0 -top-3 left-4 bg-red-600 opacity-100'>{favoriteCounts}</p>)}
              </Link>
            </div>
            {auth?.token &&
              <button  className="mx-1  bg-white rounded-full  ssm:w-7 ssm:h-7  w-6 h-6  flex items-center justify-center lg:hidden " onClick={() => { setShowSidebar(!showSidebar) }} style={{ "boxShadow": "rgb(0 0 0 / 20%) 0px 1px 1px 1px, rgb(217 215 215 / 82%) -1px -3px 4px 1px" }} >
                {showSidebar ? <img className='ssm:w-2.5 ssm:h-2.5 w-2 h-2  ' src={close} alt="not found " />
                  : <img className='ssm:w-2.5 ssm:h-2.5 w-2 h-2' src={hamburger} alt="not found " />}
              </button>
            }


          </div>

        </div>
      </nav>

      {showSidebar &&
        <div className='bg-[#000000b5] top-0 ease-in-out duration-500 fixed z-10  w-screen h-screen ' onClick={() => { setShowSidebar(!showSidebar) }} >

        </div>

      }
            
      <Sidebar />
      
    </>

  )
}

export default Header
